import Button from '@material-ui/core/Button';
import axios from 'axios';
import { withSnackbar } from 'notistack';
import React, { Component } from 'react';
import { handleChangeEvent, handlePost } from '../../../../../utils/AxiosUtil';
import * as enums from '../../../../../utils/EnumMapping';
import * as util from '../../../../../utils/Util';
import ErrorAwareAmountField from '../../../../common/inputfields/ErrorAwareAmountField';
import ErrorAwareMonthDatePicker from '../../../../common/inputfields/ErrorAwareMonthDatePicker';
import MyCreatableAutocomplete from '../../../../common/inputfields/MyAutocomplete';
import NewAgainField from '../../../../common/inputfields/NewAgainField';
import PaymentMethodFormControl from '../../../../common/inputfields/PaymentMethodFormControl';

class NewSalary extends Component {

    state = {
        newAgain: false,
        selectedPaymentMethod: enums.outPaymentMethods[0],
        selectedEmployee: {},
        netSalary: '',
        name: '',
        id: '',
        date: new Date(),
        errors: new Map(),
    }

    resetForm = () => {
        this.setState({
            newAgain: false,
            selectedPaymentMethod: enums.outPaymentMethods[0],
            selectedEmployee: {},
            netSalary: '',
            name: '',
            id: '',
            date: new Date(),
            errors: new Map(),
        })
    }

    handleSubmit = async (event) => {
        event.persist()
        event.preventDefault();

        const path = '/api/salary';
        const requestObject = {
            "paymentMethod": this.state.selectedPaymentMethod.value,
            "netSalary": util.toNumber(this.state.netSalary),
            "employeeId": this.state.selectedEmployee.value,
            "month": this.state.date.getMonth() + 1,
            "year": this.state.date.getFullYear(),
        };
        handlePost(path, requestObject, this);
    };

    promiseEmployeeOptions = async () => {
        const params = {
            type: 'FULL_TIME'
        };
        const response = await axios.get('/api/employees', { params })
        const renamedCustomers = [];
        response.data.map((resp) =>
            renamedCustomers.push({
                label: resp.employee.name,
                value: resp.employee.privateId,
                netSalary: resp.employee.currentNetSalary,
                paymentMethod: resp.employee.paymentMethod,
            }));
        return renamedCustomers;
    };

    handleEmployeeSelected = (e, v) => {
        console.log(v);
        let p = enums.getObjectByValue(enums.outPaymentMethods, v.paymentMethod);
        this.setState({ selectedEmployee: v, netSalary: v.netSalary, selectedPaymentMethod: p })
    }

    render() {
        return (
            <form onSubmit={this.handleSubmit}>
                <div className='flex-form'>
                    <div className='input-group'>
                        <MyCreatableAutocomplete
                            value={this.state.selectedEmployee}
                            defaultvale={this.state.selectedEmployee}
                            getOptions={this.promiseEmployeeOptions}
                            onChange={this.handleEmployeeSelected}
                            label={'Munkavállaló'}
                        />
                    </div>
                    <div className='input-group'>
                        <PaymentMethodFormControl
                            options={enums.outPaymentMethods}
                            value={this.state.selectedPaymentMethod}
                            onChange={e => handleChangeEvent(e, this)} />
                    </div>
                    <div className='input-group'>
                        <ErrorAwareAmountField
                            required
                            name="netSalary"
                            label="Nettó fizetés"
                            value={this.state.netSalary}
                            errors={this.state.errors}
                            onChange={e => handleChangeEvent(e, this)} />
                    </div>
                    <div className='input-group'>
                        <ErrorAwareMonthDatePicker
                            required
                            name="date"
                            errors={this.state.errors}
                            value={this.state.date}
                            onChange={value => this.setState({ date: value })}
                        />
                    </div>
                </div>
                <div className="form-actions">
                    <NewAgainField
                        checked={this.state.newAgain}
                        onChange={e => this.setState({ newAgain: e.target.checked })} />
                    <Button className="btn-submit" variant="contained" color="primary" type="submit">
                        Hozzáadás
                    </Button>
                </div>
            </form>
        )
    }
}

export default withSnackbar(NewSalary);
